module.exports = __webpack_public_path__ + "static/img/funny_24.698e906c.jpg";